/**
 * Calculate the maximum refundable amount for a payment
 * Takes into account transaction statuses and the transaction system implementation date
 *
 * @param {Object} payment - The payment object
 * @param {Array} payment.transactions - Array of transaction objects
 * @param {number} payment.amount - The original payment amount
 * @param {string} payment.createdAt - The payment creation date
 * @returns {number} The maximum refundable amount
 */
export function calculateMaximumRefundAmount(payment) {
  // The date of when the transactions were implemented - https://github.com/checkout-page/checkoutpage-api/pull/268
  const mergeDate = new Date('2025-06-19T02:34:18.000Z');

  const maximumRefundAmount =
    payment.transactions && payment.transactions.length > 0
      ? payment.transactions.reduce(
          (acc, transaction) => {
            if (transaction.status === 'refunded' || transaction.status === 'partially_refunded') {
              return acc - transaction.amount;
            }

            if (transaction.status === 'paid' && transaction.provider === 'stripe') {
              return acc + transaction.amount;
            }

            return acc;
          },
          // Safety check: if any paid transactions exist, trust those over date-based logic
          payment.transactions.some(t => t.status === 'paid' && t.provider === 'stripe')
            ? 0 // Start with 0 and only count paid transactions
            : new Date(payment.createdAt) < mergeDate && payment.status === 'paid'
              ? payment.amount // Legacy payment logic
              : 0, // No paid transactions, start with 0
        )
      : payment.status === 'paid'
        ? payment.amount
        : 0;

  return maximumRefundAmount;
}
